import { z } from "zod";

export const ImageSchema = z.object({
  title: z.string(),
  description: z.string(),
  fileUrl: z.string(),
  contentType: z.string(),
});

export const PhysicalProductDetailsSchemaBase = z.object({
  id: z.string(),
  name: z.string(),
  slug: z.string(),
  type: z.string(),
  subtype: z.optional(z.string()),
  maxQuantity: z.number(),
  orderedQuantity: z.number(),
  longDescriptionHTML: z.string(),
  priceCents: z.number(),
  images: z.array(ImageSchema),
  profileImages: z.array(ImageSchema),
  fontsInUse: z.array(z.string()),
  technicalDetailsHTML: z.optional(z.string()),
  careInformationHTML: z.optional(z.string()),
  createdAt: z.string(),
  imageDisplayMode: z.string(),
  relatedProducts: z.array(z.any()),
});

type PhysicalProductDetailsSchemaType = z.infer<
  typeof PhysicalProductDetailsSchemaBase
> & {
  relatedProducts: PhysicalProductDetailsSchemaType[];
};

export const PhysicalProductDetailsSchema: z.ZodType<PhysicalProductDetailsSchemaType> =
  PhysicalProductDetailsSchemaBase.extend({
    relatedProducts: z.lazy(() => PhysicalProductDetailsSchema.array()),
  });

export const PhysicalProductDetailsArraySchema = z.array(
  PhysicalProductDetailsSchema
);
